<template lang="pug">
.featured-challenge-small
  .banner.has-text-centered
    .banner-title.is-uppercase {{ 'Featured ' + challengeType(featuredChallenge) +' Challenge' }}
  RouterLink(
    v-if="featuredChallenge.id"
    :to="{ name: 'Challenge', params: { challengeId: featuredChallenge.id } }"
  )
    BImage.challenge-image(
      :src="_.get(featuredChallenge, 'map.image', 'https://walkertracker.s3.amazonaws.com/newui/placeholder/challenge_placeholder.jpg')"
      alt="challenge image"
    )
  .columns.is-mobile
    .column.is-hidden-tablet-only
      WtTitle(h4)
        RouterLink(
          v-if="featuredChallenge.id"
          :to="{ name: 'Challenge', params: { challengeId: featuredChallenge.id } }"
        ) {{ _.get(featuredChallenge, "name", "Featured Challenge") }}
      .subtitle.is-size-6.has-text-grey {{ betweenDates }}
      .is-size-6(v-if="featuredChallenge.memberCount || featuredChallenge.teamCount") {{ participantCountText }}
    .column.is-narrow.has-text-right.has-text-left-tablet-only
      ChallengeJoinButton(:challenge="featuredChallenge")
  WtDisplayRichTextHTML.content.pb-4(:html="description")
</template>

<script>
import { challengeMixin } from "@/mixins/challengeMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import WtDisplayRichTextHTML from "@@/WtDisplayRichTextHTML/WtDisplayRichTextHTML";
import ChallengeJoinButton from "@@/Challenge/ChallengeJoinButton";

export default {
  name: "FeaturedChallengeSmall",

  components: { WtTitle, WtDisplayRichTextHTML, ChallengeJoinButton },

  mixins: [challengeMixin],

  props: {
    featuredChallenge: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    betweenDates() {
      const startDate = this.moment(
        this._.get(this.featuredChallenge, "startDate", "")
      );
      const endDate = this.moment(
        this._.get(this.featuredChallenge, "endDate", "")
      );
      const startDateFormatted = startDate.isValid()
        ? startDate.format("MM/DD/YY")
        : " __ / __ / __ ";
      const endDateFormatted = endDate.isValid()
        ? endDate.format("MM/DD/YY")
        : " __ / __ / __ ";

      return `${startDateFormatted} - ${endDateFormatted}`;
    },

    description() {
      const description = this.mapDescription(this.featuredChallenge);

      return this._.truncate(description, { length: 150 });
    },

    participantCountText() {
      let singularText =
        this.featuredChallenge.between === "groups"
          ? this.featuredChallenge.teamCount + " Team"
          : this.featuredChallenge.memberCount + " Participant";

      return this.featuredChallenge.teamCount > 1 ||
        this.featuredChallenge.memberCount > 1
        ? singularText + "s"
        : singularText;
    }
  }
};
</script>

<style lang="sass" scoped>
.featured-challenge-small
  .banner
    margin-top: -$box-padding
    margin-left: -$box-padding
    width: calc(100% + #{$box-padding*2})
    height: $box-padding
    border-radius: $radius $radius 0 0
    background-color: $navy
    margin-bottom: 0
    &-title
      color: $white
  .challenge-title
    min-width: 10rem
    max-width: 20rem
  .subtitle
    margin-bottom: .2rem
  .challenge-image
    margin-left: -$box-padding
    margin-bottom: 1rem
    width: calc(100% + #{$box-padding*2})
  .columns
    margin-bottom: .1rem
</style>
